import { rateOptions, qualificationOptions, statusOptions } from '@/shared/constants/userEnums';
import { accountLifecycleStatusLabels } from '@/shared/constants/accountDeletion';
import type { AccountLifecycleStatus } from '@/shared/model/types/accountDeletion';
import { dateFormatFromBack } from '@/shared/lib/utils/dateFormat';

const valueMaps: Record<string, { value: string; label: string }[]> = {
  rate: rateOptions,
  qualification: qualificationOptions,
  status: statusOptions,
};

const dateFields = ['birthDate', 'licenseStartAt', 'licenseEndAt'];

export const formatLogValue = (field: string, value: unknown): string => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  if (field === 'isActive') {
    const isTrue = value === true || value === 1 || value === '1' || String(value).trim().toLowerCase() === 'true';
    return isTrue ? 'Активен' : 'Не активен';
  }

  if (field === 'accountStatus') {
    const status = String(value) as AccountLifecycleStatus;
    return accountLifecycleStatusLabels[status] ?? String(value);
  }

  if (typeof value === 'boolean') {
    return value ? 'да' : 'нет';
  }
  if (typeof value === 'number') {
    if (value === 1) return 'да';
    if (value === 0) return 'нет';
  }
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase();
    if (v === 'true' || v === '1') return 'да';
    if (v === 'false' || v === '0') return 'нет';
  }

  if (dateFields.includes(field)) {
    const str = String(value);
    if (!str) return '(не задано)';
    return dateFormatFromBack(str);
  }

  if (field in valueMaps) {
    const str = String(value);
    const option = valueMaps[field].find((opt) => opt.value === str);
    return option ? option.label : str;
  }

  return String(value);
};
